import globalStore from '../index';
import { apis } from '@/services/api';

let pasajeroApi = apis.pasajerosApi;
let choferesApi = apis.choferesApi;

// initial state
const state = {
    history: []
};

// getters
const getters = {
    list: state => state.history
};

// actions
const actions = {
    get (store, data) {
        let api = globalStore.getters['auth/isChofer'] ? choferesApi : pasajeroApi;
        return api.listado(data).then((data) => {
            store.commit('SET_HISTORY', data);
        }).catch((error) => {
            if (error) {

            }
        });
    }
};

// mutations
const mutations = {
    SET_HISTORY (state, data) {
        state.history = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/history.js